// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-components-parameter-module-parameter-module-content-actions-container-ParameterModuleContentActionsContainer-module__container-UHyJuh","saveButtonsContainer":"src-domain-components-parameter-module-parameter-module-content-actions-container-ParameterModuleContentActionsContainer-module__saveButtonsContainer-Fi8fK5"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-components-parameter-module-parameter-module-content-actions-container-ParameterModuleContentActionsContainer-module__container-UHyJuh\",\"saveButtonsContainer\":\"src-domain-components-parameter-module-parameter-module-content-actions-container-ParameterModuleContentActionsContainer-module__saveButtonsContainer-Fi8fK5\"}";
        // 1793705032676
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  